module.exports = __webpack_public_path__ + "assets/img/China-Singapore.7d28ac9d.png";